module.exports = __webpack_public_path__ + "img/güneyLogo.f0506298.png";